import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { ArrowLeft, FileText } from 'lucide-react';
import { Button } from 'components/ui/button';
import { Badge } from 'components/ui/badge';
import { Input } from 'components/ui/input';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from 'components/ui/table';
import LoadingState from 'components/shared/LoadingState';
import { blogGenVideos } from '../../../services/api';
import { errMsg } from './util';

export default function VideoPicker() {
  const navigate = useNavigate();
  const [videos, setVideos] = useState(null);
  const [manual, setManual] = useState('');

  useEffect(() => {
    blogGenVideos().then((d) => setVideos(d.videos || [])).catch((e) => { toast.error(errMsg(e)); setVideos([]); });
  }, []);

  const go = (id, title) => navigate(`/blog/generate?video=${encodeURIComponent(id)}&title=${encodeURIComponent(title || id)}`);

  if (!videos) return <LoadingState message="Loading videos…" />;

  return (
    <div>
      <div className="mb-3 flex items-center gap-3">
        <Button variant="ghost" size="sm" onClick={() => navigate('/blog')}><ArrowLeft /> Blog</Button>
        <h1 className="text-token-lg font-semibold">New post from a YouTube video</h1>
      </div>
      <div className="mb-3 flex items-center gap-2">
        <Input placeholder="…or paste a YouTube video id / URL" value={manual} onChange={(e) => setManual(e.target.value)} className="h-9 max-w-md" />
        <Button size="sm" variant="outline" disabled={!manual.trim()} onClick={() => {
          const m = manual.match(/(?:v=|youtu\.be\/|shorts\/)([A-Za-z0-9_-]{6,20})/) || [null, manual.trim()];
          go(m[1], m[1]);
        }}>Use</Button>
      </div>
      <div className="overflow-auto rounded-token-large border border-borderGrey bg-white">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-[140px]">Video</TableHead>
              <TableHead>Title</TableHead>
              <TableHead className="w-[120px]">Published</TableHead>
              <TableHead className="w-[220px]">Posts</TableHead>
              <TableHead className="w-[140px]" />
            </TableRow>
          </TableHeader>
          <TableBody>
            {videos.map((v) => (
              <TableRow key={v.id}>
                <TableCell><img src={v.thumbnail} alt="" className="h-[68px] w-[120px] rounded object-cover" /></TableCell>
                <TableCell className="text-token-md">{v.title}</TableCell>
                <TableCell className="text-token-base text-muted-foreground">{v.published ? new Date(v.published).toLocaleDateString() : ''}</TableCell>
                <TableCell>
                  <div className="flex flex-wrap gap-1">
                    {(v.posts || []).map((p) => (
                      <button key={p.id} type="button" onClick={() => navigate(`/blog/generate/${p.id}`)}>
                        <Badge variant={p.status === 'published' ? 'success' : p.status === 'pending_review' ? 'warning' : 'secondary'}>#{p.id} {p.status}</Badge>
                      </button>
                    ))}
                    {(v.posts || []).length === 0 && <span className="text-token-base text-muted-foreground">—</span>}
                  </div>
                </TableCell>
                <TableCell>
                  <Button size="sm" onClick={() => go(v.id, v.title)}><FileText /> {(v.posts || []).length ? 'New post' : 'Make post'}</Button>
                </TableCell>
              </TableRow>
            ))}
            {videos.length === 0 && <TableRow><TableCell colSpan={5} className="py-8 text-center text-muted-foreground">No videos found</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
